// Merker für den ersten App-Start (Roadmap KA-33). Bewusst winzig und ohne Abhängigkeiten:
// das Dashboard liest hier, ob der Ablauf überhaupt nachgeladen werden muss.
//
// - Willkommen: einmal je Konto (Schlüssel mit userId), auf diesem Gerät gemerkt.
// - Push-Erklärung: einmal je Gerät, weil iOS/Android die Erlaubnis je Gerät führen.
// - Zweite Chance im Live-Pop-up: einmal je Gerät, nie öfter.
// Fehlt localStorage (privater Modus), erscheint der Ablauf eben noch einmal. Das ist okay.

const WELCOME_PREFIX = "cc_app_welcome_";
// v2 seit 09.10.2026 (App-Test): Der alte Merker „cc_push_erklaert“ stammte teils aus früheren
// Bundles (Frage nie wirklich gesehen oder vor dem Pilot-Schalter). Mit v2 kommt die Frage auf
// jedem Gerät noch genau einmal, aber nur, solange iOS/Android die Erlaubnis noch als
// „prompt“ (nie gefragt) führt. Wer schon erlaubt oder abgelehnt hat, sieht nichts.
export const PUSH_ERKLAERT_KEY = "cc_push_erklaert_v2";
const ZWEITE_CHANCE_KEY = "cc_push_zweite_chance";

function lesen(key: string): string | null {
  try { return window.localStorage.getItem(key); } catch { return null; }
}
function schreiben(key: string, value: string): void {
  try { window.localStorage.setItem(key, value); } catch { /* egal */ }
}

export function willkommenErledigt(userId: string): boolean { return lesen(WELCOME_PREFIX + userId) === "1"; }
export function willkommenMerken(userId: string): void { schreiben(WELCOME_PREFIX + userId, "1"); }

/** Push-Erklärung schon gezeigt? Dann nie wieder ungefragt (Abnahme KA-09: nicht drängeln). */
export function pushErklaert(): boolean { return lesen(PUSH_ERKLAERT_KEY) === "1"; }
export function pushErklaertMerken(): void { schreiben(PUSH_ERKLAERT_KEY, "1"); }

export function zweiteChanceGenutzt(): boolean { return lesen(ZWEITE_CHANCE_KEY) === "1"; }
export function zweiteChanceMerken(): void { schreiben(ZWEITE_CHANCE_KEY, "1"); }
